import paths from "./path";
import pageTitle from "./pageTitle";

const EnglishTranslations = {
    paths,
    pageTitle,
    common: {
        appName: "ShareYourStream",
        reducedAppName: "SyS"
    }
};
  
export default EnglishTranslations;
  